export const NOVO_GRUPO_FORM_ID = "novo-grupo-form";

export const NOVO_GRUPO_TITULO = "Novo grupo";
export const ADICIONAR_LABEL = "Adicionar";
export const TIPOS_LABEL = "Tipos de obra";
export const TIPOS_AJUDA =
  "Grupo de docagem pode valer para o 101, o 102 ou os dois. O 103 vale sozinho, porque os grupos dele têm subgrupos.";
export const NOME_LABEL = "Nome do grupo";
export const NOME_PLACEHOLDER = "Ex.: Guindaste";
export const SUBGRUPOS_LABEL = "Subgrupos";
export const SUBGRUPOS_AJUDA_VAZIO = "Marque os tipos de obra para ver os subgrupos.";
export const SUBGRUPOS_AJUDA_DOCAGEM =
  "Grupos do 101 e do 102 não têm subgrupo. Os escopos do grupo são cadastrados depois, em Escopos macro padrão.";
export const SUBGRUPOS_AJUDA_103 =
  "Todo grupo do 103 tem os subgrupos Intermediária e Overhaul. Os escopos do grupo são cadastrados depois, em Escopos macro padrão.";

export const NOME_MAXIMO = 30;
export const NOME_OBRIGATORIO = "Informe o nome do grupo";
export const TIPOS_OBRIGATORIO = "Selecione ao menos um tipo de obra";

/** Tipos de Obra que aceitam grupo; a regra de quem aceita e a de duplicidade são do core. */
export const CODIGOS_DOCAGEM = ["101", "102"] as const;
export const CODIGO_PARADA = "103";
export const CODIGOS_COM_GRUPO: readonly string[] = [...CODIGOS_DOCAGEM, CODIGO_PARADA];

/** Subgrupos que o core cria com todo grupo do 103. */
export const SUBGRUPOS_DO_103 = ["Intermediária", "Overhaul"] as const;
